module.exports = "/img/toyota.6a925a64.png";